import { Colors } from '@sigma-frontend-libs/commons'
import { PAYMENTS_STATUSES } from '@sigma-legacy-libs/essentials/lib/constants'

import { icons } from '@/utils'

export const paymentStatusIcons = {
  [PAYMENTS_STATUSES.init]: icons.schedule,
  [PAYMENTS_STATUSES.completed]: icons.check_circle_outline,
  [PAYMENTS_STATUSES.refundRequested]: icons.replay,
  [PAYMENTS_STATUSES.refunded]: icons.reply_all,
  [PAYMENTS_STATUSES.partialRefunded]: icons.reply,
  [PAYMENTS_STATUSES.error]: icons.error_outline
}

export const paymentStatusColors = {
  [PAYMENTS_STATUSES.init]: Colors.grey,
  [PAYMENTS_STATUSES.completed]: Colors.success,
  [PAYMENTS_STATUSES.refundRequested]: Colors.info,
  [PAYMENTS_STATUSES.refunded]: Colors.info,
  [PAYMENTS_STATUSES.partialRefunded]: Colors.info,
  [PAYMENTS_STATUSES.error]: Colors.error
}
